import { render, staticRenderFns } from "./QuicksightS3Integration.vue?vue&type=template&id=0eb4450c&scoped=true&"
import script from "./QuicksightS3Integration.vue?vue&type=script&lang=ts&"
export * from "./QuicksightS3Integration.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eb4450c",
  null
  
)

export default component.exports